'use strict';

import _ from 'underscore';
import cookies from 'js-cookie';
import mediator from '../../js/mediator';
import config from '../../js/config';
import {runRequest} from '../../utilities/makeRequest';
import ModalView from '../../js/components/ModalView';
import template from './templates/CmsModal.hbs';

let instance = null;

export default class CmsModal extends ModalView {
  initialize() {
    super.initialize({ template });
  }

  /**
   * Opens the modal
   *
   * @param {string} contentId
   */
  open(contentId) {
    super.open();
    this.renderCmsModalContent(contentId);
  }

  /**
   * Load the CMS content for the given contentId and renders it in the modal
   *
   * @param {string} contentId
   * @returns {Promise}
   */
  renderCmsModalContent(contentId) {
    let languageCode = cookies.get(config.cookies.arrowLanguage);
    return runRequest({
      url: `/${languageCode}${config.urls.cmsModal}`,
      dataType: 'json',
      data: { contentId }
    })
      .then(request => {
        this.render({ loaded: true, ...request.response });
      });
  }

  /**
   * Render the modal content
   *
   * @param {object} [data = { loaded: false }]
   */
  render(data = { loaded: false }) {
    this.$el.html(template(data));
  }

  /**
   * Trigger the open event for a given element
   *
   * Obtains the contentId to send to the server from the elements modalContentId data attribute.
   *
   * @param {HTMLElement} el
   * @fires config.events.cmsModal.show
   * @returns {boolean}
   */
  static triggerEventForElement(el) {
    let contentId = el.dataset.modalContentId;

    if (!contentId) {
      return false;
    }

    mediator.trigger(config.events.cmsModal.show, contentId);

    return true;
  }

  /**
   * Get the singleton instance of the CmsModal.
   *
   * @returns {CmsModal}
   */
  static getInstance() {
    if (!instance) {
      instance = new CmsModal();
    }

    return instance;
  }
}

/**
 * Listen for the show modal event.
 *
 * Will only ever run the function once so that multiple listeners will not be added.
 * Creates the modal on demand, but only one instance will ever be made.
 *
 * @listens config.events.cmsModal.show
 */
export const createCmsModal = _.once(() => {
  mediator.on(config.events.cmsModal.show, contentId => CmsModal.getInstance().open(contentId));
});

/**
 * Add click events to open CmsModal.
 *
 * @param {jQuery} $parent
 */
export function createCmsModalCta($parent) {
  let $openers = $parent.find('.CmsModal-opener');

  if ($openers.length) {
    $openers.on('click', e => {
      if (CmsModal.triggerEventForElement(e.currentTarget)) {
        e.preventDefault();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./assets/components/CmsModal/CmsModal.js